<template>
  <div class="widget white_box">
    <div class="widget_header">
      <h3 class="tw-text-neutral-900 tw-text-2xl">
        Average Local Ranking <small>({{ type }})</small>
      </h3>
      <DefaultButton
        v-if="!editing && !preview"
        size="small"
        as="a"
        href="/local/gmb/rankings"
      >
        See more
      </DefaultButton>
      <div
        v-if="editing && !preview"
        class="edit_buttons tw-flex tw-gap-2"
      >
        <DefaultButton
          size="small"
          variant="primary-inverted"
          @click="$parent.edit(widget)"
        >
          Options
        </DefaultButton>

        <DefaultButton
          size="small"
          variant="danger"
          @click="$parent.remove(widget)"
        >
          Delete
        </DefaultButton>
      </div>
    </div>
    <apexchart
      v-if="!loading && !error"
      :options="chartOptions"
      :series="series"
      height="300"
      type="line"
    />

    <div
      v-if="loading && !error"
      class="loading_widget_data"
    >
      <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
    </div>

    <div
      v-if="error"
      class="widget_error"
      v-html="error"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import axios from 'axios';
import _ from 'lodash';
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

export default {
  components: {
    DefaultButton,
  },
  props: {
    widget: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: true,
      error: null,
      type: 'Maps',
      series: [{
        name: "Desktops",
        data: []
      }],
      options: {
        colors: ['#0c9bef', '#969696'],
        xaxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
          type: 'datetime',
        },
        yaxis: {
          reversed: true,
          min: 1,
          max: 100,
          forceNiceScale: true
        },
        tooltip: {}
      },
    }
  },
  computed: {
    ...mapState('dashboard', ['chartBaseOptions', 'uuid', 'preview']),
    chartOptions() {
      return {
        ...this.chartBaseOptions,
        ...this.options
      };
    }
  },
  watch: {
    'widget.average_type': {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.fetchData();
      }
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.type = this.widget.average_type;
      this.loading = true;
      axios.post('/ajax/dashboard/get-widget-data', {
        type: 'averageLocalRanking',
        average_type: this.widget.average_type,
        uuid: this.uuid,
      }).then(response => {
        let tempType = this.type;
        this.series[0].name = this.widget.average_type;
        this.series[0].data = response.data.data;
        this.options.xaxis.categories = response.data.labels;
        this.options.yaxis.max = tempType === 'Maps' ? 100 : 3;
        this.options.yaxis.tickAmount = tempType === 'Maps' ? 6 : 2;
        this.options.tooltip = {
          y: {
            formatter: function (value) {
              if (value === 101) {
                // For Map Results data, if 101 returned, display as '>100'
                return `${tempType === 'Maps' ? '>100' : '>3'}`;
              }
              return value;
            }
          },
          x: {
            format: 'd MMM yyyy',
          }
        };
        this.loading = false;
      }).catch(error => {
        this.error = error.response.data;
        this.loading = false;
      });
    }
  },
}
</script>
